function cache(key: string, def: any = {}) {
  return (
    (window.localStorage.getItem(key) &&
      JSON.parse(window.localStorage.getItem(key) as any)) ||
    def
  );
}

export default {
  query: cache('dashboard-query', {}),
  queryTemporary: cache('dashboard-query', {}),
  sortBy: '',
}
